const getHeaders = () => {
  return {
      "x-access-token": localStorage.getItem("e-portal-access-token"),
      "x-access-time": new Date().toISOString()
  }
};

export default getHeaders;